"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DefaultBanner;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const DefaultBanner_module_scss_1 = __importDefault(require("./DefaultBanner.module.scss"));
const sanitise_1 = require("../../../utils/sanitise");
const breakpoints_1 = require("../../../constants/breakpoints");
const dispatchAnalytics_1 = require("../../../utils/dispatchAnalytics");
const bannerUtils_1 = require("../../../utils/bannerUtils");
function DefaultBanner({ associatedAdvertId, bannerCampaignName, logoUrl, logoAltText, title, url, ctaText, desktopImageUrl, tabletImageUrl, mobileImageUrl, imageAltText, description, backgroundColor, textColor, previewerSize, esiType, isWide, }) {
    const TITLE_CHAR_LIMIT = 35;
    const DESC_CHAR_LIMIT = 100;
    const color = (0, sanitise_1.sanitiseColor)(textColor);
    let bannerClassName = DefaultBanner_module_scss_1.default.banner;
    let contentClassName = DefaultBanner_module_scss_1.default.content;
    let logoClassName = DefaultBanner_module_scss_1.default.logo;
    let titleClassName = DefaultBanner_module_scss_1.default.title;
    let descriptionClassName = DefaultBanner_module_scss_1.default.description;
    let ctaClassName = DefaultBanner_module_scss_1.default.cta;
    let imageContainerClassName = DefaultBanner_module_scss_1.default.imageContainer;
    if (previewerSize) {
        bannerClassName = DefaultBanner_module_scss_1.default[`preview-banner-${previewerSize}`];
        contentClassName = DefaultBanner_module_scss_1.default[`preview-content-${previewerSize}`];
        logoClassName = DefaultBanner_module_scss_1.default[`preview-logo-${previewerSize}`];
        titleClassName = DefaultBanner_module_scss_1.default[`preview-title-${previewerSize}`];
        ctaClassName = DefaultBanner_module_scss_1.default[`preview-cta-${previewerSize}`];
        descriptionClassName = DefaultBanner_module_scss_1.default[`preview-description-${previewerSize}`];
        imageContainerClassName = DefaultBanner_module_scss_1.default[`preview-imageContainer-${previewerSize}`];
    }
    let linkOptions;
    if (previewerSize) {
        linkOptions = {
            target: url ? "_blank" : undefined,
            rel: url ? "noreferrer" : undefined,
            href: url ? url : undefined,
        };
    }
    else {
        linkOptions = { href: url };
    }
    const bannerStyle = {
        backgroundColor: (0, sanitise_1.sanitiseColor)(backgroundColor),
    };
    let containerClass = "";
    if (isWide) {
        bannerStyle.maxWidth = "1439px";
        containerClass = DefaultBanner_module_scss_1.default.bannerPremiumGridContainer;
    }
    return (react_1.default.createElement("div", { className: previewerSize ? "" : containerClass },
        react_1.default.createElement("a", Object.assign({ className: bannerClassName, "data-testid": "adtech-banner-esi", style: bannerStyle }, linkOptions, { onClick: () => {
                (0, dispatchAnalytics_1.dispatchCitrusAnalyticsEvent)({
                    action: "citrusAd.clicked",
                    adId: associatedAdvertId,
                    campaignName: bannerCampaignName,
                    type: (0, bannerUtils_1.getBannerAnalyticsType)(esiType),
                });
            } }),
            react_1.default.createElement("div", { className: contentClassName },
                (logoUrl === null || logoUrl === void 0 ? void 0 : logoUrl.length) > 0 && (react_1.default.createElement("img", { "data-testid": "adtech-banner-logo", src: logoUrl, className: logoClassName, alt: logoAltText })),
                react_1.default.createElement("p", { "data-testid": "adtech-banner-title", className: titleClassName, style: { color } }, title.substring(0, TITLE_CHAR_LIMIT)),
                react_1.default.createElement("p", { "data-testid": "adtech-banner-description", className: descriptionClassName, style: { color } }, description === null || description === void 0 ? void 0 : description.substring(0, DESC_CHAR_LIMIT)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Button_1.UnderlinedButton, { tag: "span", style: { color }, className: ctaClassName, labelText: ctaText, "data-testid": "adtech-banner-cta" }))),
            react_1.default.createElement("div", { className: imageContainerClassName },
                react_1.default.createElement("picture", null,
                    react_1.default.createElement("source", { "data-testid": "adtech-banner-src-desktop", srcSet: desktopImageUrl, media: `(min-width: ${breakpoints_1.desktop}px)` }),
                    react_1.default.createElement("source", { "data-testid": "adtech-banner-src-tablet", srcSet: tabletImageUrl, media: `(min-width: ${breakpoints_1.tablet}px)` }),
                    react_1.default.createElement("img", { "data-testid": "adtech-banner-image", src: mobileImageUrl, className: DefaultBanner_module_scss_1.default.image, alt: imageAltText }))))));
}
